var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: "新增任务",
            width: "420px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.formData,
            rules: _vm.formRules,
            "label-width": "120px",
            inline: "",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "云桌面镜像ID:", prop: "paramArray" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "北京", prop: "paramArray.cn-beijing" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "北京-云桌面镜像ID" },
                    model: {
                      value: _vm.formData.paramArray["cn-beijing"],
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.paramArray, "cn-beijing", $$v)
                      },
                      expression: "formData.paramArray['cn-beijing']",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "深圳", prop: "paramArray.cn-shenzhen" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "深圳-云桌面镜像ID" },
                    model: {
                      value: _vm.formData.paramArray["cn-shenzhen"],
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.paramArray, "cn-shenzhen", $$v)
                      },
                      expression: "formData.paramArray['cn-shenzhen']",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上海", prop: "paramArray.cn-shanghai" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "上海-云桌面镜像ID" },
                    model: {
                      value: _vm.formData.paramArray["cn-shanghai"],
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.paramArray, "cn-shanghai", $$v)
                      },
                      expression: "formData.paramArray['cn-shanghai']",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "杭州", prop: "paramArray.cn-hangzhou" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "杭州-云桌面镜像ID" },
                    model: {
                      value: _vm.formData.paramArray["cn-hangzhou"],
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.paramArray, "cn-hangzhou", $$v)
                      },
                      expression: "formData.paramArray['cn-hangzhou']",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "更新版本:", prop: "updateVersion" } },
            [
              _c("el-input", {
                staticStyle: { width: "240px" },
                attrs: { placeholder: "3.2.1" },
                model: {
                  value: _vm.formData.updateVersion,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "updateVersion", $$v)
                  },
                  expression: "formData.updateVersion",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "任务描述:", prop: "remark" } },
            [
              _c("el-input", {
                staticStyle: { width: "240px" },
                attrs: { placeholder: "描述此次更新任务的目的" },
                model: {
                  value: _vm.formData.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "执行时间:", prop: "startDate" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "240px" },
                attrs: {
                  type: "date",
                  placeholder: "选择日期",
                  "value-format": "yyyy-MM-dd",
                  "picker-options": _vm.expireTimeOption,
                },
                model: {
                  value: _vm.formData.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "startDate", $$v)
                  },
                  expression: "formData.startDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "start-time",
              attrs: { label: " ", prop: "startTime" },
            },
            [
              _c("el-time-select", {
                staticStyle: { width: "240px" },
                attrs: {
                  disabled: !_vm.formData.startDate,
                  placeholder: "选择时间",
                  "picker-options": {
                    start: "00:00",
                    step: "00:15",
                    end: "24:00",
                  },
                },
                model: {
                  value: _vm.formData.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "startTime", $$v)
                  },
                  expression: "formData.startTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { type: "flex", justify: "end" },
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saveLoading,
                  },
                  on: { click: _vm.onSave },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }